<div class="d-flex flex-column w-100 flex-fill">
  <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
    <li [ngbNavItem]="1">
      <a ngbNavLink>User Information</a>
      <ng-template ngbNavContent>
        <ng-container *ngIf="userProfile$|async as userProfile" class="mt-3">
          <div class="d-flex justify-content-between">
            <div class="d-flex flex-column">
              <div class="d-flex"><b>Username:</b><span class="ms-2">{{userProfile.username}}</span></div>
              <div class="d-flex"><b>Roles:</b><span class="ms-2">{{userProfile.roles | json}}</span></div>
            </div>
            <div>
              <button class="btn btn-danger mx-4" (click)="logout()">Logout</button>
            </div>

          </div>

        </ng-container>
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <a ngbNavLink>Cache Manager</a>
      <ng-template ngbNavContent>
        <ul class="list-group list-group-flush">
          <li class="list-group-item" *ngIf="cachedItems.length < 1; else cachedItemsTempl"><small>There are currently
              no cached items</small></li>
          <ng-template #cachedItemsTempl>
            <li class="list-group-item" *ngFor="let item of cachedItems">
              <div class="d-flex flex-column">
                <div class="d-flex">
                  <a class=" me-2 text-danger text-underline" style="cursor: pointer"
                    (click)="removeCacheItem(item.key)"><i class="fa fa-times"></i></a>
                  <small><b>{{item.key}}</b></small>

                </div>
                <small><span class="me-2">Expiration:</span><span>{{(item.value.expiration | date:'M/dd/yyyy hh:mm a') || '[no
                    expiration]'}}</span></small>

                <small class="text-muted" *ngIf="!item.visible else shownVal" style="cursor: pointer;"
                  (click)="toggleVisible(item)">Show
                  Value</small>
                <ng-template #shownVal>
                  <small class="text-muted" style="cursor: pointer;" (click)="toggleVisible(item)">Hide Value</small>
                  <pre><code>{{item.value | json}}</code></pre>
                </ng-template>

              </div>
            </li>
          </ng-template>
        </ul>
      </ng-template>
    </li>

  </ul>

  <div [ngbNavOutlet]="nav" class="mt-2"></div>

  <ng-template #loader>
    <app-loader></app-loader>
  </ng-template>
</div>
